<template>
    <client-layout title="Dashboard">
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 dark:text-gray-200 leading-tight">
                Dashboard
            </h2>
        </template>

    </client-layout>
</template>

<script>
import {defineComponent} from 'vue';
import ClientLayout from '@/Layouts/ClientLayout';

export default defineComponent({
    components: {
        ClientLayout,
    },
})
</script>
